import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanySwift = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      label={t('external_invoices.missing_company_compliance_details.modal.form.field.swift_bic.label')}
      name="swift"
      render={({ field }) => <Input {...field} size="sm" />}
    />
  )
}
